jQuery(document).ready(function($) {
    const RealmCustomerType = {
        init: function() {
            this.initModal();
            this.initButtons();
        },

        initModal: function() {
            const modal = $('#customer-type-modal');
            if (modal.length) {
                modal.addClass('is-active');

                // Prevent closing modal when clicking outside
                modal.on('click', function(e) {
                    if ($(e.target).is('.modal-background, .modal-close, .modal-card-head .delete')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                });

                // Prevent closing modal with ESC key
                $(document).on('keydown.customerTypeModal', function(e) {
                    if (e.key === 'Escape' && modal.hasClass('is-active')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                });

                // Prevent any other scripts from closing the modal
                const observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            if (!modal.hasClass('is-active')) {
                                modal.addClass('is-active');
                            }
                        }
                    });
                });

                observer.observe(modal[0], {
                    attributes: true
                });
            }
        },

        initButtons: function() {
            // Handle topbar buttons
            $('.customer-type-selector .customer-type-btn').on('click', function(e) {
                e.preventDefault();
                const $btn = $(this);
                const type = $btn.data('type');
                
                // Add loading state only to clicked button
                $btn.addClass('is-loading').prop('disabled', true);
                
                RealmCustomerType.setCustomerType($btn, type);
            });

            // Handle modal buttons
            $('.customer-type-buttons .customer-type-btn').on('click', function(e) {
                e.preventDefault();
                const $btn = $(this);
                const type = $btn.data('type');
                
                // Add loading state only to clicked button
                $btn.addClass('is-loading').prop('disabled', true);
                
                RealmCustomerType.setCustomerType($btn, type);
            });
        },

        setCustomerType: function($btn, type) {
            $.ajax({
                url: realmCustomerType.ajaxurl,
                type: 'POST',
                data: {
                    action: 'set_customer_type',
                    nonce: realmCustomerType.nonce,
                    type: type
                },
                success: function(response) {
                    if (response.success) {
                        // Stop observing before closing modal
                        if (typeof observer !== 'undefined') {
                            observer.disconnect();
                        }
                        
                        // Close modal if it's open
                        if ($('#customer-type-modal').hasClass('is-active')) {
                            $('#customer-type-modal').removeClass('is-active');
                        }
                        
                        // Remove loading state from clicked button
                        $btn.removeClass('is-loading').prop('disabled', false);
                        
                        // Remove the event handler
                        $(document).off('keydown.customerTypeModal');
                        
                        // Reload page to update prices and external product URLs
                        window.location.reload();
                    } else {
                        // Reset loading state if there's an error
                        $btn.removeClass('is-loading').prop('disabled', false);
                    }
                },
                error: function() {
                    // Reset loading state if there's an error
                    $btn.removeClass('is-loading').prop('disabled', false);
                }
            });
        }
    };

    // Initialize the customer type functionality
    RealmCustomerType.init();
}); 